document.addEventListener('DOMContentLoaded', () => {
    const heroSwiper = new Swiper('.hero-swiper', {
		slidesPerView: 1,
		loop: true,
		speed: 600,
		effect: "fade",
		autoplay: {
			delay: 4500,
		},
	});
	const sliderSwiper = new Swiper('.slider-swiper', {
		navigation: {
			nextEl: ".slider-next",
			prevEl: ".slider-prev",
		},
		loop: true,
		slidesPerView: 1,
		speed: 800,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		autoplay: {
			delay: 7000,
		},
		on: {
			init: function () {
				document.querySelectorAll('.slider-swiper .slider-next, .slider-swiper .slider-prev').forEach(button => {
					button.classList.remove('swiper-button-lock');
					button.style.display = ''; 
				});
			},
			slideChange: function () {
				document.querySelectorAll('.slider-swiper .slider-next, .slider-swiper .slider-prev').forEach(button => {
					button.classList.remove('swiper-button-lock');
					button.style.display = '';
				});
			},
			resize: function () {
				// Garantizar que las flechas sigan visibles al redimensionar la ventana
				document.querySelectorAll('.slider-swiper .slider-next, .slider-swiper .slider-prev').forEach(button => {
					button.classList.remove('swiper-button-lock');
					button.style.display = '';
				});
			}
		}
	});
	const sliderMobileSwiper = new Swiper('.slider-mobile', {
		loop: true,
		slidesPerView: 1.5,
		centeredSlides: true,
		spaceBetween: 25,
		speed: 800,
		navigation: {
			nextEl: ".slider-next",
			prevEl: ".slider-prev",
		},
		autoplay: {
			delay: 6000,
		},
	});
	const cardsSwiper = new Swiper('.cards-swiper', {
		loop: true,
		speed: 800,
		spaceBetween: 25,
		navigation: {
			nextEl: ".sw-next",
			prevEl: ".sw-prev",
		},
		breakpoints: {
			320: {
				slidesPerView: 1.3,
				spaceBetween: 15,
				centeredSlides: true,
			},
			700: {
				slidesPerView: 2,
				centeredSlides: false,
			},
			900: {
				slidesPerView: 3,
			}
		},
		on: { 
			slideChange: function() {
			  	this.slides.forEach(el => el.classList.remove("active"))
			}}
	});
	const galleryMiniSwiper = new Swiper('.gallery-mini-swiper', {
		loop: true,
		speed: 800,
		spaceBetween: 25,
		navigation: {
			nextEl: ".sw-next",
			prevEl: ".sw-prev",
		},
		autoplay: {
			delay: 3000,
		},
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			700: {
				slidesPerView: 2
			},
			900: {
				slidesPerView: 3
			}
		}
	});
	const colsSwiper = new Swiper('.cols-swiper', {
		loop: true,
		speed: 800,
		navigation: {
			nextEl: ".cols-next",
			prevEl: ".cols-prev",
		},
		autoplay: {
			delay: 7000,
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
			},
			900: {
				slidesPerView: 2,
				spaceBetween: 55
			}
		}
	});
	const imgSwiper = new Swiper('.img-swiper', {
		loop: true,
		slidesPerView: 1.2,
		spaceBetween: 15,
		centeredSlides: true,
		speed: 400,
		initialSlide: 1,
		navigation: {
			nextEl: ".gallery-next",
			prevEl: ".gallery-prev",
		}
	});
});